import { LOGO_IMAGE, ARTICLE_IMAGE_CLASS } from 'constant'

export const scrollToPreviousPositionOnThePage = () => {
  const body = document.querySelector('body')

  if (!sessionStorage.scrollPos) {
    body.addEventListener('scroll', (event) => {
      sessionStorage.scrollPos = document.querySelector('body').scrollTop
    })
  }

  const init = () => {
    const options = sessionStorage.scrollPos ? { top: sessionStorage.scrollPos } : { top: 0 }
    body.scrollTo(options)
    sessionStorage.scrollPos = undefined
  }

  init()
}

export const generateArticlesSchema = (canonicalUrl, description, name, image, datePublished) =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl
    },
    headline: name,
    description,
    image: image || LOGO_IMAGE,
    author: {
      '@type': 'Organization',
      name: 'Big O Tires',
      url: 'https://www.bigotires.com'
    },
    publisher: {
      '@type': 'Organization',
      name: 'https://www.bigotires.com',
      logo: {
        '@type': 'ImageObject',
        url: LOGO_IMAGE
      }
    },
    datePublished,
    dateModified: datePublished
  })

export const getArticleImageSrcFromHTMLString = body => {
  const rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g
  const images = rex.exec(body)

  if (images === null) {
    return null
  }

  const articleImage = images.find(image => image.indexOf(ARTICLE_IMAGE_CLASS) >= 0)

  if (!articleImage) return null

  const parser = new DOMParser()
  const parsedStringToHTML = parser.parseFromString(articleImage, 'text/html')
  const articleImageElement = parsedStringToHTML.querySelector(`.${ARTICLE_IMAGE_CLASS}`)

  return articleImageElement.src
}

export const setMissingTagObserver = () => {
  const articleImage = document.querySelector('.article-image')
  const articleImageTitleAttribute = articleImage && articleImage.getAttribute('title')

  const observer = new MutationObserver(mutations => {
    mutations.forEach(record => {
      if (record.type === 'attributes') {
        const changedAttr = record.attributeName
        const newValue = record.target.getAttribute(changedAttr)
        if (changedAttr === 'alt' && newValue === '') {
          articleImage.setAttribute('alt', articleImageTitleAttribute)
        }
      }
    })
  })

  if (articleImage) {
    observer.observe(articleImage, {
      attributes: true
    })
  }
}
